import {DefaultValue, selector, selectorFamily, waitForAll} from 'recoil';

import {IContract} from '../../shared/types/contract.types';

import {
  contractPageable,
  contractsQueryTrigger,
  contractsSortQueryTrigger,
  contractsState,
  currentContractIdState,
  currentContractState,
  documentsOfContractQueryTrigger,
  documentsOfCurrentContractState,
} from './atoms';

import {ContractService} from '../../api/services/contract.service';

import {companyByIdSelectorFamily} from '../company/selectors';
import {currentCompanyIdState, currentCompanyState} from '../company/atoms';

export const currentContractSelector = selector({
  key: 'currentContractSelector',
  get: ({get}) => {
    const {content: contracts} = get(contractsState);
    const index = get(currentContractIdState);

    return contracts.find((i) => i.id === index) as IContract;
  },
});

export const contractsQuery = selector({
  key: 'contractsQuery',
  get: async ({get}) => {
    get(contractsQueryTrigger);
    const [pageable, sort] = get(waitForAll([contractPageable, contractsSortQueryTrigger]));

    const res = await ContractService.getAll({
      pageable: {
        order: [sort?.[0]?.field || 'counter', sort?.[0]?.sort === 'asc' ? 'ASC' : 'DESC'],
        ...pageable,
      },
    });

    return res.data;
  },

  set: ({set}, newValue) => {
    set(contractsState, newValue);
  },
});

export const contractsQueryForNewSR = selector({
  key: 'contractsQueryForNewSR',
  get: async ({get}) => {
    get(contractsQueryTrigger);
    const res = await ContractService.getAll({
      spec: {
        archive: false,
      },
      pageable: {
        page: 0,
        size: 200,
      },
    });

    return res.data;
  },

  set: ({set}, newValue) => {
    set(contractsState, newValue);
  },
});

export const currentContractQuery = selectorFamily({
  key: 'currentContractQuery',
  get:
    (id) =>
    async ({get}) => {
      get(contractsQueryTrigger);
      const res = await ContractService.getById(String(id));

      return res.data;
    },

  set:
    () =>
    ({set, get}, newValue) => {
      const company = !(newValue instanceof DefaultValue) ? get(companyByIdSelectorFamily(newValue.companyId)) : null;
      set(currentContractState, newValue);
      if (company) {
        set(currentCompanyState, company);
        set(currentCompanyIdState, company.id);
      }
    },
});

export const documentsOfContractQuery = selectorFamily({
  key: 'documentsOfContractQuery',
  get:
    (id) =>
    async ({get}) => {
      get(documentsOfContractQueryTrigger);
      const res = await ContractService.getDocumentsOfContract(String(id));

      return res.data.content;
    },

  set:
    () =>
    ({set}, newValue) => {
      set(documentsOfCurrentContractState, newValue);
    },
});
